import React, { Suspense, useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import i18n from "./stores/i18n";
import * as mqtt from "mqtt/dist/mqtt.min";

import Header from "./components/header";
import Footer from "./components/footer";
import Agree from "./pages/agree";
import About from "./pages/about";
import About1_1 from "./pages/about1_1";
import About1 from "./pages/about1";
import About2 from "./pages/about2";
import About3 from "./pages/about3";
import Start from "./pages/about_2";
import Main from "./pages/main";
import Login from "./pages/login";
import Policy from "./pages/policy";
import Service from "./pages/service";
import Readys from "./pages/result_ready";
import Result from "./pages/result";

import useClientStore from "./stores/client";

function App() {
    const { client, setClient, onMessage } = useClientStore();
    const onMessageRef = useRef(onMessage);

    useEffect(() => {}, []);

    useEffect(() => {
        onMessageRef.current = onMessage;
    }, [onMessage]);

    useEffect(() => {
        const url = process.env.REACT_APP_MQTT_URL;

        const client = mqtt.connect(url);

        client.on("connect", () => {
            setClient(client);
        });
        client.on("close", function () {
            setClient(null);
        });
        client.on("reconnect", () => {});

        client.on("message", (topic, message) => {
            if (onMessageRef.current[topic]) {
                onMessageRef.current[topic](topic, message);
            }
        });

        setClient(client);

        return () => {
            if (client) {
                client.end(() => {
                    //console.log("disconnect");
                });
            }
        };
    }, []);

    return (
        <>
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/agree" element={<Agree />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/about1_1/:name" element={<About1_1 />} />
                    <Route path="/about1/:name/:sex" element={<About1 />} />
                    <Route path="/about2/:name/:sex/:birth" element={<About2 />} />
                    <Route path="/about3/:name/" element={<About3 />} />
                    <Route path="/about_2/:name/:birth/:member_no/:device_no/:device_sn" element={<Start />} />
                    <Route path="/result_ready" element={<Readys />} />
                    <Route path="/result" element={<Result />} />
                    <Route path="/login" element={<Login />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </>
    );
}

export default App;
